import { Menu } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'

export default function DropdownMenu({ label, items }) {
  return (
    <Menu as="li" className="relative">
      <Menu.Button className="flex items-center py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">
        {label}
        <ChevronDownIcon className="w-4 h-4 ml-2" />
      </Menu.Button>

      <Menu.Items className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg border dark:bg-gray-800 z-50">
        <div className="py-1 text-gray-700 dark:text-white">
          {items.map(({ to, label }, index) => (
            <Menu.Item key={index}>
              {({ active }) => (
                <Link
                  to={to}
                  className={`block px-4 py-2 ${active ? 'bg-gray-100 dark:bg-gray-700' : ''}`}
                >
                  {label}
                </Link>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
}